import { render, staticRenderFns } from "./instrucoesinternas.vue?vue&type=template&id=542033a5&scoped=true"
import script from "./instrucoesinternas.vue?vue&type=script&lang=js"
export * from "./instrucoesinternas.vue?vue&type=script&lang=js"
import style0 from "./instrucoesinternas.vue?vue&type=style&index=0&id=542033a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542033a5",
  null
  
)

export default component.exports